import type { CreateProjectRequest, ResponsiblePersonInput } from '@/api/generated/schemas';
import { RESPONSIBILITY_ROLE_FIELDS } from '@/modules/planner/responsibleRoles';
import type { ProjectFormValues } from './projectFormSchema';

/**
 * Transformace hodnot formuláře na API request. Create i Update mají shodný tvar těla, takže
 * stačí jeden builder; výsledek je `satisfies CreateProjectRequest` (kompilátor hlídá shodu s BE).
 *
 * Rozdíly form ↔ command: formulář drží bohaté UI objekty (destinace, osoby), API chce jen id;
 * projekt je kořen, takže každá vyplněná role je origin (`isOverridden: true`).
 */
export function toProjectRequestBody(values: ProjectFormValues): CreateProjectRequest {
  const responsiblePersons: ResponsiblePersonInput[] = RESPONSIBILITY_ROLE_FIELDS.flatMap(
    (field) => {
      const person = values.responsiblePersons[field.key];
      if (!person) return [];
      return [{ role: field.role, isOverridden: true, personPartyId: person.partyId }];
    }
  );

  return {
    name: values.name.trim(),
    destinationIds: values.destinations.map((destination) => destination.destinationId),
    responsiblePersons,
  } satisfies CreateProjectRequest;
}
